import moment from 'moment';
import { isNumber } from 'lodash';
import DateFormat from 'constants/date_format';

function hasCapOption(maxAttendees) {
  return maxAttendees >= 1;
}

/**
 * Converts the session object that we get from the backend to the shape that
 * the SessionForm component expects as prop.defaultState
 */
export default function serializeSessionToFormState(session) {
  return {
    capOption: hasCapOption(session.max_attendees),
    startTime: moment(session.start_time, DateFormat.fixed.ISO8601_LOCAL),
    endTime: moment(session.end_time, DateFormat.fixed.ISO8601_LOCAL),
    location: session.location || '',
    maxAttendees: session.max_attendees || '',
    trainerId: isNumber(session.trainer.id)
      ? session.trainer.id.toString()
      : '',
    timeZone: session.time_zone.name,
    videoConferencing: session.video_meeting || {
      type: 'none',
      url: '',
      id: null,
      host_id: null,
    },
  };
}
